import { isPhoneOrHighScreen } from '@/utilities/sizeUtils';
import { Popup } from '@/components/common/Popup';
import TargetAttributesPanel from './TargetAttributesPanel';
import { useState } from 'react';
import TargetAttributesMobileHeader from './TargetAttributesMobileHeader';
import TargetAttributesMobileBody from './TargetAttributesMobileBody';
import TargetAttributesMobileFooter from './TargetAttributesMobileFooter';

export type TargetAttributesTabs = 'TargetTab' | 'DriverTab' | 'UsersTab';

export default function TargetAttributesPopup({ closePopup }: { closePopup: () => Promise<void> }) {
  const [activeTab, setActiveTab] = useState<TargetAttributesTabs>('TargetTab');

  const header = undefined;
  const body = (
    <div className="targetattributes-popup-container">
      <TargetAttributesPanel />
    </div>
  );

  if (isPhoneOrHighScreen()) {
    return (
      <Popup
        popupTitle={undefined}
        header={<TargetAttributesMobileHeader activeTab={activeTab} setActiveTab={setActiveTab} />}
        body={<TargetAttributesMobileBody activeTab={activeTab} setActiveTab={setActiveTab} />}
        footer={<TargetAttributesMobileFooter />}
        closePopup={closePopup}
        isFullScr={true}
        showCloseButton={false}
        leftText={true}
      />
    );
  }

  return (
    <>
      {header}
      {body}
    </>
  );
}
